import { Request } from "@tools/base";;
const { Axios } = Request;

const URL = "/";

//判断U本位合约是否开通
export function get_fapiAccountOpen(config?) {
  return Axios.get(URL + `v1/future-u/user/compat/account/open`, config);
}

//判断币本位合约是否开通
export function get_dapiAccountOpen(config?) {
  return Axios.get(URL + `v1/future-c/user/compat/account/open`, config);
}

//U本位合约可划转币种列表
export function get_fapiCoins(config?) {
  return Axios.get(URL + `v1/future-u/user/public/compat/coins`, config);
}

//币本位合约可划转币种列表
export function get_dapiCoins(config?) {
  return Axios.get(URL + `v1/future-c/user/public/compat/coins`, config);
}

//股票可划转的币种
export function get_equityCoins(config?) {
  return Axios.get(URL + `v1/spot/fund/equity/compat/coins`, config);
}

// 股票划转金额限制
export function get_equityTransLimit(config?) {
  return Axios.post(URL + `v1/spot/fund/equity/transfer/limit`, config);
}

//U本位合约获取资产列表
export function get_fapiBalanceList(config?) {
  return Axios.get(URL + `v1/future-u/user/compat/balance/list`, config);
}

//币本位合约获取资产列表
export function get_dapiBalanceList(config?) {
  return Axios.get(URL + `v1/future-c/user/compat/balance/list`, config);
}


